import { ToolRegistry } from "@openanalyst-ai/ui/message-part"
import { InlinePluginViewRenderer } from "./inline-plugin-view"

let registered = false

export function registerInlinePluginView() {
  if (registered) return
  const render = ToolRegistry.render.bind(ToolRegistry)
  // Plugin view tool names are workspace-defined, so exact renderers win first and
  // dynamic *.view tools fall back to the readonly inline plugin renderer.
  ToolRegistry.render = (name: string) => render(name) ?? (isPluginViewTool(name) ? InlinePluginViewRenderer : undefined)
  registered = true
}

registerInlinePluginView()

function isPluginViewTool(name: string) {
  return name === "generate_image" || name === "generate_video" || name.endsWith(".view") || name.includes(".view:")
}
